import React from 'react';
import { Delete } from 'lucide-react';

function NumberKeypad({ onNumberClick, onDelete, onClear }) {
  const numbers = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['C', '0', '.']
  ];

  const handleClick = (value) => {
    if (value === 'C') {
      onClear();
    } else if (value === '.') {
      onNumberClick('.');
    } else {
      onNumberClick(value);
    }
  };

  return (
    <div className="grid grid-cols-3 gap-2">
      {numbers.flat().map((num, idx) => (
        <button
          key={idx}
          onClick={() => handleClick(num)}
          className={`
            h-14 rounded-lg font-semibold text-lg transition-all
            ${num === 'C'
              ? 'bg-red-100 text-red-700 hover:bg-red-200'
              : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
            }
            active:scale-95
          `}
        >
          {num}
        </button>
      ))}
      {/* Delete button spanning full width below */}
      <button
        onClick={onDelete}
        className="col-span-3 h-14 rounded-lg font-semibold text-lg transition-all bg-red-100 text-red-700 hover:bg-red-200 active:scale-95 flex items-center justify-center gap-2"
      >
        <Delete className="w-5 h-5" />
        Borrar
      </button>
    </div>
  );
}

export default NumberKeypad;